import React from "react";
import Navbar from '../Components/Navbar';
import { isMobile } from "react-device-detect";
import 'glightbox/dist/css/glightbox.css';
import SmartAi from "../Components/SmartAi";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const Creche = () => {
    return (
        <div>
            <Navbar />

            {/* HERO SECTION */}
            <section className="bg-white pb-lg-6 pb-4 px-lg-6 px-0">
                <div className="container">
                    <div className="row pt-lg-10 pt-6 pb-lg-6 px-lg-0">

                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 mb-6 mb-lg-0"
                        >
                            <div className="text-center text-md-start">
                                <div className="text-muted text-uppercase mb-2 fs-6">
                                    Nurturing God-Given Potentials From The Start
                                </div>
                                <div className="fs-m fw-semibold mb-2 text-dark">
                                    Creche & Pre-School Program.
                                </div>
                            </div>

                            <div className={`fs-4 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                                At Ebun Heritage Schools, our Creche and Pre-School program is carefully designed to provide a warm,
                                nurturing, and stimulating environment for our youngest learners. We believe that early childhood
                                is the foundation upon which lifelong learning is built.
                                <br /><br />
                                Through guided play, structured activities, storytelling, music, creativity, and supervised exploration,
                                we help children develop cognitive, emotional, spiritual, and social skills. Our dedicated educators
                                provide individualized attention to ensure every child feels valued, secure, and inspired.
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 text-center"
                        >
                            <img
                                src="../../assets/images/background/creche1.png"
                                alt="Ebun Heritage Creche"
                                width={500}
                                className="img-fluid mb-lg-4"
                            />
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 text-center mt-lg-n16"
                        >
                            <img
                                src="../../assets/images/background/creche2.png"
                                alt="Ebun Heritage Preschool"
                                width={500}
                                className="img-fluid mb-lg-4"
                            />
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 mb-6 mb-lg-0 mt-lg-8 mt-4"
                        >
                            <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                                We <u className="text-primary"><span className="text-dark-blue">Offer The Best.</span></u>
                            </div>

                            <div className={`fs-4 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                                Our early years curriculum embraces a holistic approach to development —
                                nurturing academic readiness, moral values, spiritual awareness, discipline,
                                and creativity.
                                <br /><br />
                                Safety, hygiene, and emotional security are top priorities in our creche.
                                We partner closely with parents to ensure continuity between home and school,
                                helping each child discover their dreams and develop confidence from the earliest stage.
                            </div>
                        </motion.div>

                    </div>
                </div>
            </section>


            {/* CONTACT + GOAL SECTION */}
            <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
                <div className="container">

                    {/* Contact Card */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="px-lg-18 mt-lg-n14 mt-n8"
                    >
                        <div className="card shadow-lg bg-dark-blue p-4 p-lg-6" style={{ borderRadius: '30px' }}>
                            <div className="d-lg-flex text-center justify-content-center">

                                <div>
                                    <div className="fs-5 text-white">Get In Touch:</div>
                                    <div className="fs-3 text-white">
                                        admin@ebunheritageschool.com
                                    </div>
                                </div>

                                <div className="mx-4">
                                <button className="btn btn-icon btn-white shadow-lg fw-semibold py-4 px-4 fs-5 rounded-circle">
                                    OR
                                </button>
                                </div>

                                <div>
                                    <div className="fs-5 text-white">Call Us Via:</div>
                                    <div className="fs-3 text-white">
                                    +234 906 216 8062
                                    </div>
                                </div>

                            </div>
                        </div>
                    </motion.div>


                    {/* Our Goal Section */}
                    <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">

                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 mb-6 mb-lg-0"
                        >
                            <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                                Our <u className="text-primary"><span className="text-dark-blue">Goal.</span></u>
                            </div>

                            <div className={`fs-4 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                                At Ebun Heritage Schools, our goal is to harness the God-given potentials in every child,
                                guiding them to discover purpose, excellence, and integrity from an early age.
                                <br /><br />
                                We aim to cultivate academic brilliance, moral discipline, spiritual growth,
                                and leadership qualities within a safe and dynamic learning environment.
                                Our creche and pre-school lay the foundation for confident, responsible,
                                and globally minded learners who will positively impact their communities and the world.
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            className="col-lg-6 text-center"
                        >
                            <img
                                src="../../assets/images/background/value.png"
                                alt="Ebun Heritage Goal"
                                width={500}
                                className="img-fluid mb-lg-4"
                            />
                        </motion.div>

                    </div>
                </div>
            </section>

            <Core />
            <Footer />
        </div>
    );
};

export default Creche;
